import Skeleton from 'react-loading-skeleton';

export const ShapeSquare = ({ className = '' }) => {
	return <Skeleton containerClassName={`flex w-full h-full ${className} `} className='flex' />;
};
